export default {
  '成绩列表':'成績列表',
  '锻炼时间':'鍛鍊時間',
  '导出数据':'導出數據',
  '或':'或',
  '设为无效':'設為無效',
  '恢复有效':'恢復有效',
  '视频回放':'影片回放',
  '比赛记录':'比賽記錄',
  '最佳成绩':'最佳成績',
  '完成时间':'完成時間',
  '个人榜':'個人榜',
  '比赛明细':'比賽明細',
  '管理人员可通过视频情况将成绩处理为“无效”，无效的成绩不会参与任何排行，请慎重操作！':'管理人員可通過影片情況將成績處理為「無效」，無效的成績不會參與任何排行，請慎重操作！',
  '请输入用户姓名，学校名模糊搜索':'請輸入用戶姓名，學校名模糊搜尋',
}